module.exports = __webpack_public_path__ + "static/media/award-star-head.6dcb7347.svg";